var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3"},[_c('p',{staticClass:"font-weight-bold text-lg mt-2"},[_vm._v(" Mapa ")]),_c('z-map',{staticClass:"parcel-detail-map rounded",attrs:{"id":"parcel-map","destinations":_vm.destinations}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }